export enum WindowTypes {
	desktop = 'desktop',
	laptop = 'laptop',
	tablet = 'tablet',
	mobile = 'mobile',
}
export type TWindowType = keyof typeof WindowTypes;
export type ABTest = Record<string, 'A' | 'B' | 'C'>;

/* --- STATE --- */
export interface PageStoreState {
	windowType: TWindowType;
	isSmallScreen: boolean;
	abTesting: ABTest;
}
